var map = {
	"./radissonblu (2).jpg": 1564,
	"./radissonblu (3).jpg": 7583,
	"./radissonblu (4).jpg": 5478,
	"./radissonblu (5).jpg": 9633,
	"./radissonblu (6).jpg": 9384,
	"./radissonblu (7).jpg": 6731,
	"./radissonblu (8).jpg": 1714,
	"./radissonblu.jpg": 2535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5274;